<template>
  <div v-if="typeof newEditor === 'boolean'">
    <editor v-if="newEditor" />
    <resume v-else />
  </div>
</template>

<script>
import resume from "./cvsEditor/index";
import editor from "../editor2025/index.vue";
import api from "@/api/index";
export default {
  name: "index",
  data() {
    return {
      newEditor: null,
    };
  },
  mounted() {},
  computed: {},
  watch: {},
  components: {
    resume,
    editor,
  },
  methods: {
    async getExperimentResult() {
      const [res1, res2] = await Promise.all([
        api.jobs.getBanner({ position: 159 }),
        this.$store.dispatch('me/getUserInfo'),
      ]);
      if (res1.code === 1000 && res2.code === 1000 && res1.data?.[0]?.title) {
        const { title } = res1.data[0];
        const { id } = res2.data;

        const experimentArr = title?.split(",") || [];

        this.newEditor = experimentArr.includes(id?.toString()?.slice(-1));
      } else {
        this.newEditor = true;
      }
    },
  },
  created() {
    this.getExperimentResult();
  },
};
</script>

<style lang="scss" scoped></style>
